export const initialState = {
  boards: [],
  sortType: 'activity',
  searchText: '',
  loading: false
}
